var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#242424;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34 -1107)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,1A2,2,0,0,0,1,3v9a2,2,0,0,0,2,2h9a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H3M3,0h9a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(34 1107)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4202.935 2189.025)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4239.972-1071.708a3.748,3.748,0,0,0,2.689-.758,2.654,2.654,0,0,1-.365-.05,1.841,1.841,0,0,1-1.311-1.14c-.036-.088-.03-.093.065-.079a1.888,1.888,0,0,0,.651-.027.3.3,0,0,0,.044-.018,1.832,1.832,0,0,1-1.425-1.816,1.845,1.845,0,0,0,.81.215,1.839,1.839,0,0,1-.792-1.3,1.78,1.78,0,0,1,.233-1.138.583.583,0,0,1,.12.126,5.182,5.182,0,0,0,3.037,1.713c.187.034.375.049.563.068.062.006.064-.013.056-.067a1.8,1.8,0,0,1,.368-1.487,1.776,1.776,0,0,1,1.721-.672,1.741,1.741,0,0,1,1,.508.114.114,0,0,0,.124.031,3.693,3.693,0,0,0,1.008-.383c.02-.011.041-.02.079-.039a1.89,1.89,0,0,1-.755.989,3.435,3.435,0,0,0,1-.267,3.414,3.414,0,0,1-.443.548,3.166,3.166,0,0,1-.416.36.118.118,0,0,0-.051.11,5.264,5.264,0,0,1-2.282,4.518,4.73,4.73,0,0,1-2.193.825,5.392,5.392,0,0,1-2.214-.161,5.034,5.034,0,0,1-1.286-.577C4240-1071.682,4239.994-1071.69,4239.972-1071.708Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d19987530fd680392287fc993ba24714.svg";
export { ForwardRef as ReactComponent };